<template>
  <content-container :overlay="false">
    <new-password-modal ref="new-password-modal-ctrl"></new-password-modal>

    <simple-card :loading="loading" id="user-password">
      <template v-slot:title>
        {{ $t("profile.auth.pass.title") }}
      </template>
      <template v-slot:description>
        {{ $t("profile.auth.pass.desc") }}
      </template>
      <template v-slot:pane>
        <b-button variant="primary" @click="showChangePassword()">{{
          $t("profile.auth.pass.change")
        }}</b-button>
      </template>
    </simple-card>
  </content-container>
</template>

<script>
import ContentContainer from "@/components/ContentContainer";
import SimpleCard from "@/components/SimpleCard";
import { SETUP_FROM_DATA } from "@/store/consts";
import NewPasswordModal from "@/components/user-profile/NewPasswordModal";
import { URL_LOAD_USER } from "@/globals";

export default {
  name: "UserAuthentication",
  components: {
    ContentContainer,
    SimpleCard,
    NewPasswordModal,
  },
  data: () => ({
    loading: false,
  }),
  methods: {
    showChangePassword: function () {
      this.$refs["new-password-modal-ctrl"].show();
      //this.showEmailModal = true
    },
  },
  created() {
    // Токен должен быть свежим, перечитаем пользователя с сервера
    this.$get(URL_LOAD_USER, true)
      .then((result) => {
        // Обновим экземпляр пользователя
        this.$store.dispatch(SETUP_FROM_DATA, result);
      })
      .catch((e) => {
        // Странный случай, предложим войти в кабинет
        this.$router.push({ name: "sign-in" });
        this.$alert.show(e);
      });
  },
};
</script>

<style scoped>
</style>